import React, { useState, useEffect } from 'react';
import style from './RoleManage.module.css';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiSearch } from 'react-icons/ci';
import Button from '../../components/Basic/button';
import FormModal from '../../components/Modal/FormModal';
import Features from '../../Forms/RoleForm'
import Header from '../../components/Header/header';
import { connect } from 'react-redux';
import * as Actions from "../../store/slices/role/roles"
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import { useNavigate } from 'react-router-dom';

interface Api {
    Role_Red: any;
    getAllRole: (page: number, size: number) => unknown;
    getRole: (id: number) => void;
}


interface DataSource {
    key: string;
    RoleName: string;
    Description: string;
    Active: string;

}

const MultiViewTable: React.FC<Api> = ({ Role_Red, getAllRole, getRole }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['RoleName', 'Description', 'Active',]);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [open, setOpen] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('')
    const [selectedRole, setSelectedRole] = useState<any>(null);
    const [isFetchingEdit, setIsFetchingEdit] = useState(false);

    console.log(selectedRole, 'select')

    const apiResponse = Role_Red?.data?.[0]?.res?.data;
    const roles = apiResponse?.content || [];
    const total = apiResponse?.totalElements || 0;
    const loading = false;

    // Security Policy: Check for status codes 1004 and 1005
    useEffect(() => {
        if (Role_Red?.dataSingle?.[0]?.res?.status === '1004') {
            message.error(Role_Red.dataSingle[0].res.message);
            localStorage.clear();
            navigate('/');
        } else if (Role_Red?.dataSingle?.[0]?.res?.status === '1005') {
            message.warning(Role_Red.dataSingle[0].res.message);
        }
    }, [Role_Red, navigate]);

    const openForm = (role: any = null) => {
        if (!role) {
            setSelectedRole(null);
            setShowForm(true);
            return;
        }

        setIsFetchingEdit(true);
        setSelectedRole(role);
        getRole(role.roleId);
    };

    useEffect(() => {
        if (!selectedRole) return;

        const detailed = Role_Red?.getByID?.data;

        if (
            detailed &&
            Number(detailed.roleId) === Number(selectedRole.roleId)
        ) {
            setShowForm(true);
            setIsFetchingEdit(false);
        }
    }, [Role_Red?.getByID?.data, selectedRole]);

    useEffect(() => {
        if (!showForm) {
            setSelectedRole(null);
            setIsFetchingEdit(false);
        }
    }, [showForm]);

    useEffect(() => {
        getAllRole(
            currentPage,
            pageSize
        );
    }, [getAllRole, currentPage, pageSize]);


    const filteredData = roles.filter((item: any) =>
        item.name?.toLowerCase().includes(searchText) ||
        item.description?.toLowerCase().includes(searchText)
    );

    console.log(Role_Red, 'sd')



    const onSearch = (value: string) => setSearchText(value.toLowerCase());

    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };




    const Addhandle = () => {
        setShowForm(true);
    };

    const Backhandle = () => {
        setShowForm(false); // Show the table and hide the form
    };

    const HandleDelete = () => {
        setModalText('Are you sure you want to delete this record?');
        setOpen(true);
    }
    // const HandleApprove = () => {
    //     setModalText('Approve Campaign');
    //     setOpen(true);
    // }


    const actionMenu = (
        <Space direction="vertical" className={style.actions}>

            {hasPermission(PERMISSIONS.ROLE_UPDATE) && (
                <div className={style.dropdownItem} onClick={Addhandle}>Edit</div>
            )}
            {/* <div className={style.dropdownItem} onClick={HandleDelete}>Delete</div> */}
        </Space>
    );




    const allColumns = [
        {
            title: 'Role Name',
            dataIndex: 'name',
            key: 'RoleName',
            width: 180,
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'Description',
            width: 450,
            sorter: (a: any, b: any) => a.description.localeCompare(b.description),
        },
        {
            title: 'Active',
            key: 'Active',
            width: 100,
            render: (_: any, record: any) => (
                <>{record.active === true || record.active === 'true' ? 'Active' : 'Inactive'}</>
            ),
            sorter: () => 0,
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right' as const,
            width: 60,
            render: (_: any, record: any) => {           // ← record = current row
                const actionMenu = (
                    <Space direction="vertical" className={style.actions}>
                        {hasPermission(PERMISSIONS.ROLE_UPDATE) && (

                            <div
                                className={style.dropdownItem}
                                onClick={() => openForm(record)}   // ← pass the role object
                            >
                                Edit
                            </div>
                        )}
                        {/* <div className={style.dropdownItem} onClick={HandleDelete}>
                            Delete
                        </div> */}
                    </Space>
                );

                return (
                    <Dropdown overlay={actionMenu} trigger={['click']} placement="bottomRight">
                        <CiMenuKebab className={style.actionIcon} />
                    </Dropdown>
                );
            },
        },
    ];
    const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

    // const filteredData = dataSource.filter((item) =>
    //     item.RoleName.toLowerCase().includes(searchText) ||
    //     item.Description.toLowerCase().includes(searchText) ||
    //     item.Active.toLowerCase().includes(searchText)
    // );

    const items = [

        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('RoleName')}
                    value={'RoleName'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'RoleName')}
                >
                    RoleName
                </Checkbox>
            ),
            key: '2',
        },

        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Description')}
                    value={'Description'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Description')}
                >
                    Description
                </Checkbox>
            ),
            key: '4',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Active')}
                    value={'Active'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Active')}
                >
                    Active
                </Checkbox>
            ),
            key: '5',
        },


    ];


    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])


    return (
        <>
            <Header />
            <FormModal modalTitle={modalText} Subtitle={modalText} open={open} setOpen={setOpen} onOk={() => console.log('object')} onCancel={() => console.log('Modal cancelled')} />
            {showForm ? (
                <Features roleId={selectedRole?.roleId} Back={Backhandle} initialValues={selectedRole} isEdit={!!selectedRole} />
            ) : (
                // Render the table when not showing the form
                <>
                    <div className={style.Route}>
                        <h5>Role Management</h5>
                        <div className={style.btns}>
                            {hasPermission(PERMISSIONS.ROLE_CREATE) && (

                                <Button
                                    Text={'Create Role'}
                                    buttonClass={style.createBtn}
                                    onClick={Addhandle}
                                    Disable={loadingText}
                                />
                            )}
                        </div>
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    // suffix={<CiFilter size={20} className={style.filterIcon} />}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                        </Space>
                        <Table
                            loading={loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData}
                            pagination={false}
                            // rowSelection={{
                            //     type: 'checkbox',
                            // }}
                            size="small"
                            onChange={(pagination, filters, sorter) => {
                                if (!Array.isArray(sorter)) {
                                    console.log('Field:', sorter.field);
                                    console.log('Order:', sorter.order);
                                }
                            }}
                        />
                        <Pagination
                            align="end"
                            showTotal={(tot) => `Total ${tot} items`}
                            current={currentPage}
                            total={total}
                            pageSize={pageSize}
                            pageSizeOptions={['10', '20', '50']}
                            showSizeChanger
                            onChange={(page, size) => {
                                setCurrentPage(page);
                                setPageSize(size);
                            }}
                            style={{ marginTop: 16 }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

function mapStateToProps(state: any) {
    return {
        Role_Red: state.Role_Red
    }
}

export default connect(mapStateToProps, Actions)(MultiViewTable)